import { render, staticRenderFns } from "./AccountingBook.vue?vue&type=template&id=2b6b389c&scoped=true"
import script from "./AccountingBook.vue?vue&type=script&lang=js"
export * from "./AccountingBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b389c",
  null
  
)

export default component.exports